module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-c1c788f0e487b29a618367e91a62205a.svg";